import { Flex, Segment, SegmentGroup, Text } from "@simplybusiness/mobius";
import type { PriceSummaryProps } from "./types";

const PriceRow = ({
  label,
  value,
  isBold,
}: {
  label: string;
  value: string;
  isBold?: boolean;
}) => (
  <Flex className="mobius-price-summary__row">
    <Text>{isBold ? <strong>{label}</strong> : label}</Text>
    <Text>{isBold ? <strong>{value}</strong> : value}</Text>
  </Flex>
);

export const PriceSummary = ({
  downpayment,
  installments,
  total,
}: PriceSummaryProps) => {
  return (
    <SegmentGroup className="mobius-price-summary" data-testid="price-summary">
      {downpayment && (
        <Segment>
          <PriceRow label="To pay today" value={downpayment} isBold />
        </Segment>
      )}
      {installments.map((installment, index) => (
        <Segment key={index}>
          <PriceRow label={installment.label} value={installment.value} />
        </Segment>
      ))}
      <Segment>
        <Flex className="mobius-price-summary__row">
          <Text>
            Total{"\u00A0"}
            <Text elementType="span">(inc.tax + fees)</Text>
          </Text>
          <Text className="mobius-price-summary__total-value">{total}</Text>
        </Flex>
      </Segment>
    </SegmentGroup>
  );
};

PriceSummary.displayName = "PriceSummary";
